import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowId.actions.startOver', {
    msgRequestsStartOverSuccess: 'Selected request(s) will start over soon. This may take a few moments.',
});
